import { FETCH_NOTIFICATIONS, SHOW_NOTIFICATION } from './ActionType'

const initialState = {
  notifications: { data: [], total: 0 },
  allNotifications: { data: [], total: 0 },
}

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS: {
      const { notifications } = action.payload || {}
      return {
        ...state,
        notifications: notifications || { data: [], total: 0 },
        allNotifications: notifications || { data: [], total: 0 },
      }
    }
    case SHOW_NOTIFICATION:
      return {
        ...state,
        notificationBanner: action.payload,
      }
    default:
      return state
  }
}

export default notificationReducer
